const externalLinks = {
  knowledgeBase: 'https://flowtly.com/knowledge-base',
}

export default externalLinks;
